import { CouponApplyErrorCode } from "../../core/enums";
import { CouponApplyPhase } from "./interfaces/coupon-qualifier.interface";
export class CouponLimitQualifier {
    phase = CouponApplyPhase.PreApply;
    qualify(coupon, cart) {
        if (coupon.limitsPerOrder === 4 /* CouponLimitPerOrder.OVERRIDE_207 */)
            return { isValid: true, errorCode: null };
        const duplicates = cart.activeCouponIds.filter(y => y === coupon.couponId).length;
        if (coupon.limitsPerOrder > 0 && duplicates >= coupon.limitsPerOrder) {
            return { isValid: false, errorCode: CouponApplyErrorCode.COUPON_LIMIT_MET };
        }
        return { isValid: true, errorCode: null };
    }
}
//# sourceMappingURL=coupon-limit.js.map